import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { setInitData, initializeUser } from './store/userSlice';
import Main from './pages/Main';
import Welcome from './pages/Welcome';
import DeadLine from './pages/DeadLine';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import './App.css';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/main" element={<Main />} />
      <Route path="/deadline" element={<DeadLine />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/" element={<Navigate to={'/welcome'} />} />
      <Route path="*" element={<Navigate to={'/welcome'} />} />
      <Route path="/app" element={<Navigate to={'/welcome'} />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
  );
}

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const initializeTelegram = async () => {
      try {
        console.log('Starting initialization');
        if (!window.Telegram?.WebApp) {
          console.warn("Telegram WebApp not initialized");
          return;
        }

        const tg = window.Telegram.WebApp;
        tg.isOrientationLocked = true;
        tg.expand();
        tg.disableVerticalSwipes();
        tg.disableClosingConfirmation();
  
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          if (isMobile) {
            tg.expand();
            tg.requestFullscreen(); // Запрашиваем полноэкранный режим
          }
        
        const newInitData = tg.initData;
        // const newInitData = 'user=%7B%22id%22%3A304543478%2C%22first_name%22%3A%22%D0%9D%D0%B8%D0%BA%D0%BE%D0%BB%D0%B0%D0%B9%20%E2%80%A2%20ProTailor%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22protailor_ru_kg%22%2C%22language_code%22%3A%22ru%22%2C%22is_premium%22%3Atrue%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FeoAKzKGaOncH6pp6ukIOw7VSgpNZQzdtlqJ8WoUVWb0.svg%22%7D&chat_instance=-8009163075667837729&chat_type=private&auth_date=1736742188&signature=GK6tGTvxd1wmX2XteJ2iQmTcicmMMQ-RCTPJLpL1rsdKSEpVTy5g9CccOzG1Wj_Zx7KUJ5SWvTVinj-3WYWHBA&hash=5f21f5a7e68a9c7f5a050636848f84408799040d65673a863527c0a92b3687f6';
        console.log('Got initData:', newInitData);
        
        dispatch(setInitData(newInitData));
        const result = await dispatch(initializeUser(newInitData)).unwrap();
        console.log('Initialization result:', result);

        // Ждем полной загрузки страницы
        if (document.readyState === 'complete') {
          hideLoadingScreen();
        } else {
          window.addEventListener('load', hideLoadingScreen);
        }

      } catch (error) {
        console.error("Error during initialization:", error);
      }
    };

    const hideLoadingScreen = () => {
      // Добавляем небольшую задержку для уверенности
      setTimeout(() => {
        const initialLoader = document.querySelector('.loading-screen');
        if (initialLoader) {
          initialLoader.classList.add('fade-out');
          setTimeout(() => {
            initialLoader.style.display = 'none';
          }, 300);
        }
      }, 500); // Дополнительная задержка в 500мс
    };

    initializeTelegram();

    // Очистка слушателя событий
    return () => {
      window.removeEventListener('load', hideLoadingScreen);
    };
  }, [dispatch]);

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
